import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { ResponsiveIcon } from "@brexhq/next/src/components/shared/Icon";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";

import { NAV_HEIGHT } from "../../consts";

export { default as Menu } from "./Menu";
export { default as MenuButton } from "./MenuButton";
export {
  MobileCTALoadingStencil,
  MobileBottomCtasStencil,
  MobileMenuLoadingStencil,
} from "./LoadingStencil";

export const Header = styled.header(({ theme }) => ({
  zIndex: theme.zIndex.HEADER,
  position: "sticky",
  top: 0,
}));

export const Nav = styled.nav(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: theme.colors.background.primary,
  borderBottom: `1px solid ${theme.colors.border.default}`,
  color: theme.colors.content.primary,
  ...padding(theme.spacing.SML.sml / 2, theme.spacing.SML.sml),
  height: NAV_HEIGHT,
}));

export const NavItemList = styled.ul({
  display: "flex",
  alignItems: "center",
  listStyle: "none",
  height: "100%",
  padding: 0,
  margin: 0,
  gap: 10,
});

export const CtaButton = styled(CoreLink)(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  background: theme.colors.accent.primary.background.default,
  color: "white",
  borderRadius: theme.borders.radius.button.small,
  padding: theme.spacing.SML.xxsml,
}));

export const PageList = styled.ul(({ theme }) => ({
  listStyle: "none",
  display: "flex",
  flexDirection: "column",
  padding: 0,
  margin: 0,
  "> li:first-of-type": {
    borderTop: `1px solid ${theme.colors.border.default}`,
  },
}));

export const Logo = ({ disableLink }: { disableLink?: boolean }) => {
  const icon = (
    <ResponsiveIcon
      icon="RebirthLogo"
      responsive={{
        LRG: { height: 20 },
        MED: { height: 20 },
        SML: { height: 20 },
      }}
    />
  );
  return disableLink ? (
    icon
  ) : (
    <Link
      aria-label="Brex logo"
      modifier="unstyled"
      component={"nav"}
      section="logo"
      to="/"
      label="Brex logo"
    >
      {icon}
    </Link>
  );
};
